import React from 'react'

const AddFatherIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/add-father.svg" : "/assets/icons/add-father.svg"}
             alt="add father"
             style={props.style}
        />
    )
}

export default AddFatherIcon